import { Button } from "reactstrap";
import AbsenForm from "./AbsenForm";
import { useState } from "react";
import { Edit, Edit2 } from "react-feather";
import PengaturanModal from "../../../Layout/Components/PengaturanModal";

const AbsenModal = ({ row, create, dateFilter, resetState }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  const [title] = useState(create ? "Form Absen" : "Edit Absen");
  const [button] = useState(
    create ? (
      <Button
        className={
          "p-0 d-flex align-items-center justify-content-center btn-light text-success"
        }
        onClick={(e) => {
          e.preventDefault();
          toggle();
        }}
      >
        <Edit2 size={12} />
        Absen
      </Button>
    ) : (
      <Button
        className={
          "p-0 d-flex align-items-center justify-content-center btn-light text-dark"
        }
        onClick={(e) => {
          e.preventDefault();
          toggle();
        }}
      >
        <Edit size={12} />
        Ubah
      </Button>
    )
  );

  return (
    <PengaturanModal
      size={"lg"}
      button={button}
      isOpen={isOpen}
      title={title}
      toggle={toggle}
    >
      <AbsenForm
        resetState={resetState}
        toggle={toggle}
        staf={row}
        dateFilter={dateFilter}
        create={create}
      />
    </PengaturanModal>
  );
};

export default AbsenModal;
